import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { AccountModel } from "../../../domain/models";
import { RootState } from "../../store";

type ResultType = () => void;

export const useLogout = (): ResultType => {
  const navigate = useNavigate();
  const setCurrentAccount = useSelector<
    RootState,
    (account: AccountModel | undefined) => void
  >((state) => state.setCurrentAccount);
  const location = useLocation();
  return (): void => {
    localStorage.removeItem("currentWarehouse");
    if (setCurrentAccount) {
      setCurrentAccount(undefined);
    }
    navigate("/login", { state: { redirected: location.pathname } });
  };
};
